import * as Preact from "preact"
import App from "@frog/source/models/App.js"
import "./hud.less"

let bookEverOpen = false
let bookOpen = false
let pageNumber = 0
const book = [
    {
        "pageId": "cover",
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-cover.png"),
    },
    {
        "pageId": "contracttableofcontents",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-1.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-2.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-contract.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-2.png"),
    },
    {
        "pageId": "missionoverview",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-3.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-4.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-3.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-4.png"),
    },
    {
        "pageId": "nondisclosureproceedures",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-5.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-6.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-5.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-6.png"),
    },
    {
        "pageId": "demon",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-7.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-8.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-7.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-8.png"),
    },
    {
        "pageId": "eyebeast",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-9.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-10.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-9.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-10.png"),
    },
    {
        "pageId": "ghost",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-11.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-12.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-11.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-12.png"),
    },
    {
        "pageId": "unicorn",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-13.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-14.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-13.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-14.png"),
    },
    {
        "pageId": "manmoth",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-15.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-16.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-15.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-16.png"),
    },
    {
        "pageId": "mimic",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-17.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-18.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-17.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-18.png"),
    },
    {
        "pageId": "ooze",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-19.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-20.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-19.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-20.png"),
    },
    {
        "pageId": "ratking",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-21.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-22.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-21.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-22.png"),
    },
    {
        "pageId": "shadowbeast",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-23.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-24.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-23.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-24.png"),
    },
    {
        "pageId": "undead",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-25.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-26.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-25.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-26.png"),
    },
    {
        "pageId": "vampire",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-27.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-28.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-27.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-28.png"),
    },
    {
        "pageId": "angel",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-29.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-30.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-29.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-30.png"),
    },
    {
        "pageId": "werewolf",
        "leftPage": require("@frog/source/assets/images/book-tactics/pages/book-31.png"),
        "rightPage": require("@frog/source/assets/images/book-tactics/pages/book-32.png"),
        "karlLeftPage": require("@frog/source/assets/images/book-tactics/pages/book-31.png"),
        "karlRightPage": require("@frog/source/assets/images/book-tactics/pages/book-carl-32.png"),
    },
]

export default function(stage) {
    if (App?.game?.overworld?.hasHandbook) {
        if (bookOpen) {
            bookEverOpen = true
            return (
                <div class="Book">
                    <button class="ExitBook" onClick={() => bookOpen = false}>X</button>

                    <div class="InnerBook">
                        {pageNumber > 0 && (
                            <button class="GoLeft" onClick={() => pageNumber -= 1}>{"<"}</button>
                        )}
                        <div class="LeftPage"><img src={App.game.overworld.bookFlags[book[pageNumber].pageId] ? book[pageNumber].karlLeftPage : book[pageNumber].leftPage}/></div>
                        <div class="RightPage"><img src={App.game.overworld.bookFlags[book[pageNumber].pageId] ? book[pageNumber].karlRightPage : book[pageNumber].rightPage}/></div>
                        {pageNumber < book.length - 1 && (
                            <button class="GoRight" onClick={() => pageNumber += 1}>{">"}</button>
                        )}
                    </div>
                </div>
            )
        } else {
            return (
                App.game.overworld.hasHandbook && (
                    <div class="OpenBookButton">
                        <button onClick={() => bookOpen = true}>
                            OPEN BOOK
                        </button>
                        {!bookEverOpen && (
                            <div>^</div>
                        )}
                    </div>
                )
            )
        }
    }
}
